import { render, staticRenderFns } from "./RegisterStats.vue?vue&type=template&id=010cc575&scoped=true&"
import script from "./RegisterStats.vue?vue&type=script&lang=ts&"
export * from "./RegisterStats.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterStats.vue?vue&type=style&index=0&id=010cc575&prod&lang=scss&scoped=true&"
import style1 from "./RegisterStats.vue?vue&type=style&index=1&id=010cc575&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010cc575",
  null
  
)

export default component.exports